import { HackleAppInvocationProcessor, TrackInvocation } from "../invocator/HackleAppInvocationProcessor"
import BrowserPropertyProvider from "../../property/BrowserPropertyProvider"
import { PageEventTracker } from "../../../core/internal/page/PageEventTracker"
import { Engagement } from "../../../core/internal/engagement/Engagement"
import { EngagementListener } from "../../../core/internal/engagement/EngagementListener"

export class HackleAppEngagementListener implements EngagementListener {
  private static readonly ENGAGEMENT_EVENT_KEY = "$engagement"
  private static readonly ENGAGEMENT_TIME_PROPERTY_KEY = "$engagement_time_ms"

  constructor(
    private readonly invocationProcessor: HackleAppInvocationProcessor,
    private readonly browserPropertyProvider: BrowserPropertyProvider
  ) {}

  onEngagement(engagement: Engagement, timestamp: number): void {
    this.track(engagement, timestamp)
  }

  private track(engagement: Engagement, _timestamp: number): void {
    const event = {
      key: HackleAppEngagementListener.ENGAGEMENT_EVENT_KEY,
      properties: {
        ...engagement.page.properties,
        [PageEventTracker.PAGE_NAME_PROPERTY_KEY]: engagement.page.pageName,
        [HackleAppEngagementListener.ENGAGEMENT_TIME_PROPERTY_KEY]: engagement.durationMillis
      }
    }

    const invocation: TrackInvocation = {
      command: "track",
      parameters: {
        event,

        /**
         * @description use app side user instead of web side user.
         */
        user: undefined
      },
      browserProperties: this.browserPropertyProvider.getBrowserProperties(engagement.page)
    }

    this.invocationProcessor.process(invocation)
  }
}
